import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {

    baseUrl = `${baseUrl}/requisicao-abertura-fechamento`

    return {
        datatable(queryParms = {}) {

            return repository.get(`${baseUrl}/datatable?${urlUtil.serialize(queryParms)}`)
        },
        getEstoque(materialId, centroCustoAlmoxarifadoId) {

            return repository.get(`${baseUrl}/estoque/${materialId}/${centroCustoAlmoxarifadoId}`)
        },
        getMateriaisPermitidos(centroCustoAlmoxarifadoId) {

            return repository.get(`${baseUrl}/material-permitido/${centroCustoAlmoxarifadoId}`)
        },
        create() {

            return repository.get(`${baseUrl}/create`)
        },
        store(params) {

            return repository.post(`${baseUrl}`, params)
        },
        edit(id) {

            return repository.get(`${baseUrl}/${id}/edit`)
        },
        update(id, params) {

            return repository.put(`${baseUrl}/${id}`, params)
        },
        destroy(id) {

            return repository.delete(`${baseUrl}/${id}`)
        },
    }
}